<template>
  <div class="card bg-light mb-3 border-0 p-10">
    <div class="card-body">
      <div class="card-title p-2">
        <div class="row align-items-center">
          <div class="col-10">
            <titles :text="data.participantTypeName"></titles>
          </div>
          <div class="col-2 text-right">
            <el-dropdown trigger="click" @command="handleCommand">
              <el-button type="text" class="custom-button" style="padding: 0 !important;">
                <div class="square-icon">
                  <i class="fas fa-ellipsis-h" style="color: #808080;"></i>
                </div>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item :command="{ action: 'edit', id: data.id }" @click.native="handleEdit(data.id)">
                  <span style="display: inline-flex; align-items: center; width: 100%;">
                    <i class="fa-solid fa-pen-to-square" style="width: 20px; text-align: center;"></i>
                    <span>{{$t('Düzəliş')}}</span>
                  </span>
                </el-dropdown-item>

                <el-dropdown-item
                  :command="{ action: 'report', id: data.id, accidentId: data.accidentId, createUserId: data.createUser }"
                  @click.native="handleReport(data.id, data.accidentId, data.createUser)">
                  <span style="display: inline-flex; align-items: center; width: 100%;">
                    <i class="fa-solid fa-car-burst" style="width: 20px; text-align: center;"></i>
                    <span>Raport</span>
                  </span>
                </el-dropdown-item>

                <el-dropdown-item
                  :disabled="(roles.includes('Accident commissar operator') && this.readonly) || (this.uid !== data.createUser)"
                  :command="{ action: 'delete', id: data.id }" @click.native="handleDelete(data.id)">
                  <span style="display: inline-flex; align-items: center; width: 100%;">
                    <i class="fa-solid fa-trash-can" style="width: 20px; text-align: center;"></i>
                    <span>{{$t('Sil')}}</span>
                  </span>
                </el-dropdown-item>
                <el-dropdown-item
                  v-if="data.insuranceType === 1 || data.insuranceType === 2 || data.participantType === 3"
                  :command="{ action: 'certificate', id: data.id, insuranceType: data.insuranceType }"
                  @click.native="handleCertificate(data.insuranceType,data.participantType)">
                  <span style="display: inline-flex; align-items: center; width: 100%;">
                    <i class="fa-solid fa-file-pdf" style="width: 20px; text-align: center;"></i>
                    <span>Şəhadətnamə</span>
                  </span>
                </el-dropdown-item>
                <el-dropdown-item :command="{ action: 'log', id: data.id }" @click.native="showLogs(data.id)">
                  <span style="display: inline-flex; align-items: center; width: 100%;">
                    <i class="fa-solid fa-history" style="width: 20px; text-align: center;"></i>
                    <span>{{$t('Loglar')}}</span>
                  </span>
                </el-dropdown-item>

              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
        <hr width="100%" size="50" style="margin-top: 5px; margin-bottom: 5px;height: 1px;background: #F3EFE0;"
          align="left">
        <div class="row">
          <div class="col-12">
            <div class="info-item">
              <span class="info-label" style="font-weight: bold; color: #3A3A3A">
                {{ data.damageType === 1 ? $t('Sürücü')
                : data.damageType === 2 ? $t('Xəsarət_alan')
                : $t('Əmlak_sahibi') }}:
              </span>
              <span class="info-value">{{ data.partPersonName }}</span>
            </div>

            <div class="info-item">
              <span class="info-label" style="font-weight: bold; color: #3A3A3A">
                {{ data.damageType === 1 ? $t('Sürücünün_nömrəsi')
                : data.damageType === 2 ? $t('Xəsarət_alananın_nömrəsi')
                : $t('Əmlak_sahibi_nömrəsi') }}:
              </span>
              <span class="info-value">{{ data.partPersonPhone }}</span>
            </div>
            <div class="info-item">
              <span class="info-label" style="font-weight: bold; color: #3A3A3A">{{$t('Zərər_növü')}}:</span>
              <span class="info-value">{{ data.damageTypeName }}</span>
            </div>

            <span class="info-value">
              <template v-if="data.damageType === 1">
                <template v-if="data.brandName || data.modelName">
                  {{ data.brandName }} {{ data.modelName }}
                </template>
                <template v-else>
                  {{ data.customBrandModel }}
                </template>

                <template v-if="data.regNumber">
                  ,
                  <a href="javascript:;" @click="openPastAccidentsModal(data.regNumber)">
                    {{ data.regNumber }}
                  </a>
                </template>
              </template>
              <template v-else>
                {{ data.otherPropertyName }}
              </template>
            </span>

          </div>
        </div>
      </div>
    </div>
    <el-dialog title="Keçmiş hadisələr" :visible.sync="pastAccidentDialogVisible" width="600px" :modal="true">
      <div style="max-height: 400px; overflow-y: auto;">
        <el-table :data="pastAccidents" border stripe style="width: 100%;">
          <el-table-column prop="dispAccidentNumber" label="Hadisə nömrəsi" width="180">
            <template #default="scope">
              <a :href="`#/comm/accident/${scope.row.id}`" target="_blank"
                style="color: #409EFF; text-decoration: underline; cursor: pointer;">
                {{ scope.row.dispAccidentNumber }}
              </a>
            </template>
          </el-table-column>

          <el-table-column prop="accidentDateStr" label="Hadisə tarixi" />
        </el-table>
      </div>
    </el-dialog>

    <log-changes-dialog :visible.sync="logDialogVisible" :processed-log-diffs="processedLogDiffs" />

  </div>
</template>

<script>
  import {
    CopyParticipant,
    CheckPolicyStatus
  } from "../../services/accident";
  import Titles from "./Titles.vue";
  import { LastAccidentStatus } from "../../services/common";
  import { textLeft } from "../../services/helper";
  import LogChangesDialog from "../components/LogChangesDialog.vue";
  import { MongoGetLogs } from "src/services/mongo";
  import { processLogDiffs } from "src/services/loghelper";
  import { GetPastAccidentsByRegNumber } from "../../services/accident";
  export default {
    components: {
      Titles,
      LogChangesDialog
      // Upload,
    },
    props: {
      item: Object,
      readonly: { type: Boolean, default: false }
    },
    data() {
      return {
        data: this.item,
        uid: this.$store.state.user.id,
        roles: this.$store.state.user.roles,
        policyStatus: false,
        accidentStatus: null,
        textLeft: textLeft,
        logs: [],
        processedLogDiffs: [],
        logDialogVisible: false,
        methodNames: ["UpdateParticipant"],
        pastAccidents: [],
        pastAccidentDialogVisible: false,

      };
    },
    methods: {
      async openPastAccidentsModal(regNumber) {
        if (!regNumber) return;

        try {
          this.loading = true;
          const response = await GetPastAccidentsByRegNumber(regNumber);
          this.loading = false;

          if (response.data?.data) {
            this.pastAccidents = response.data.data;
            this.pastAccidentDialogVisible = true;
          } else {
            this.$message.warning("Keçmiş qəza məlumatı tapılmadı.");
          }
        } catch (error) {
          this.loading = false;

          // Konsola daha ətraflı yaz
          console.error("Keçmiş qəzanın yüklənməsi zamanı xəta baş verdi:", error);

          // UI-də dəstək üçün mesaj göstər
          const message =
            error?.response?.data?.message ||
            error?.message ||
            "Naməlum xəta baş verdi.";

          this.$message.error(`Xəta baş verdi: ${message}`);
        }
      }
      ,
      handleCertificate(insuranceType, participantType) {
        let url = "";
        if (insuranceType === 2) {
          url = "http://cm-files.progress-ims.com/Claims/2025/9/printform_1323245.pdf";
        } else if (insuranceType === 1 || participantType === 3) {
          url = "http://cm-files.progress-ims.com/Claims/2025/9/printform_2548454.pdf";
        } else {
          this.$message.warning("Şəhadətnamə üçün uyğun sığorta tipi yoxdur.");
          return;
        }

        window.open(url, "_blank");
      }
      ,
      async showLogs(id) {
        try {
          const response = await MongoGetLogs(id, this.methodNames);

          if (!Array.isArray(response.data)) {
            this.$message.error("Server ilə əlaqə yoxdur.");
            return;
          }

          const sorted = response.data.sort((a, b) => new Date(b.Timestamp) - new Date(a.Timestamp));

          this.logs = sorted.map((log) => ({
            Timestamp: log.Timestamp,
            MethodName: log.Properties?.MethodName || '',
            RequestData: log.Properties?.RequestData.Data || {}
          }));

          this.logDialogVisible = true;
        } catch (error) {
          console.error("Log error:", error);
          this.$message.error("Logları çəkmək mümkün olmadı.");
        }
      },
      handleCommand(command) {
        let id = command.id;
        let accidentId = command.accidentId;
        let createUserId = command.createUserId;
        if (command.action === "edit") this.handleEdit(id);
        else if (command.action === "delete") this.handleDelete(id);
        else if (command.action === "report") this.handleReport(id, accidentId, createUserId);
        else if (command.action === "copy") this.handleCopy(id, accidentId);

      },
      handleEdit(id) {
        this.$emit("edit", id);
      },
      handleReport(id, accidentId, createUserId) {
        this.$emit("report", id, accidentId, createUserId, this.readonly);
      },
      checkPolicyStatus() {
        this.policyStatus = false;
        return new Promise((resolve, reject) => {
          CheckPolicyStatus(this.data.accidentId).then((response) => {
            if (response.data) {
              this.policyStatus = response.data;
            }
            resolve(this.response);
          }, error => {
          })
        })
      },
      lastAccidentStatus() {
        LastAccidentStatus(this.data.accidentId).then((response) => {
          if (response && response.data) {
            this.accidentStatus = response.data;
          } else {
          }
        }).catch(error => {
        });
      }
      ,
      handleCopy(id, accidentId) {
        CopyParticipant(id, accidentId, this.uid).then((response) => {
          this.loading = false;
          if (response.data) {
            if (!response.data.isSuccess) {
              this.$message({
                type: "error",
                message: response.data.errors[0],
              });
            } else {
              this.$message({
                type: "success",
                message: "Uğurlu əməliyyat",
              });
              this.$emit("refresh");
            }
          } else {
            this.$message({
              type: "error",
              message: "Səhv əməliyyat",
            });
          }
        });
      },
      handleDelete(id) {
        this.$emit("delete", id);
      },
    },
    watch: {
      item() {
        this.data = this.item;

      },
      logs: {
        immediate: true,
        deep: true,
        async handler(newLogs) {
          this.processedLogDiffs = await processLogDiffs(newLogs, this.methodNames);
        }
      }
    },
    mounted() {
      this.lastAccidentStatus();
      this.checkPolicyStatus();

    },

  };
</script>

<style lang="scss" scoped>
  .info-item {
    margin-bottom: 2px;
    font-size: var(--font-primary);
  }

  .info-label {
    display: inline-block;
    min-width: 180px;
    margin-right: 5px;
  }

  .info-value {
    color: #333;
  }
</style>